import React from 'react';
import Header from "./Header.js";
import Hero from "./Hero.js";
import Footer from "./Footer.js";

function BusinessMode() {
  return (
    <div>
      <Header/>
      <Hero/>
      <Footer/>
    </div>
  );
}

export default BusinessMode;